module.exports = __webpack_public_path__ + "assets/img/Affiches_cover.7da2e4be.jpg";